import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core';
import Page from 'src/app/components/Page';
import './style.css';
import MapOsm2 from './MapOsm2';
import { getLicensePlateDevice, resetChange } from 'src/features/deviceSlice';
import { useQuery } from 'src/app/hooks/useQuery';

const MapView = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const query = useQuery();
  const deviceTypeId = query.get('device_type_id') || undefined;

  const isAdmin = useSelector(state => state.authSlice.isAdmin);
  const isAgency = useSelector(state => state.authSlice.isAgency);
  const isUser = useSelector(state => state.authSlice.isUser);

  useEffect(() => {
    dispatch(getLicensePlateDevice({ device_type_id: deviceTypeId }));
  }, [isAdmin, isAgency, isUser, deviceTypeId]);

  useEffect(() => {
    return () => {
      dispatch(resetChange());
    };
  }, []);

  return (
    <Page className={classes.root}>
      <div class="flex">
        <div className={classes.mapWrap}>
          <MapOsm2 />
        </div>
      </div>
    </Page>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingLeft: 0,
    paddingRight: 0
  },
  mapWrap: {
    width: '100%',
    height: 'calc(100%-66px)',
    position: 'relative'
  }
}));

export default React.memo(MapView);
